import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { loginUser } from "../../store/authSlice";

export default function Login() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { token, status, error } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const fromPath = location.state?.from?.pathname || "/";

  if (token) {
    return <Navigate to={fromPath} replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    await dispatch(loginUser({ email, password }));
  };

  return (
    <div className="care-auth-wrap">
      <div className="care-auth-card">
        <div className="care-auth-brand">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="" width={44} height={44} />
          <div className="care-auth-brand-text">
            <span className="care-auth-brand-title">Nvoisys Health</span>
            <span className="care-auth-brand-sub">Staff sign in</span>
          </div>
        </div>
        <h1 className="care-title">Welcome back</h1>
        <form className="care-form" onSubmit={handleSubmit}>
          <label className="care-field">
            <span className="care-label">Email</span>
            <input
              className="care-input"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
              required
            />
          </label>
          <label className="care-field">
            <span className="care-label">Password</span>
            <input
              className="care-input"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          {error ? <p className="care-banner care-banner--error">{error}</p> : null}
          <button className="care-button" type="submit" disabled={status === "loading"}>
            {status === "loading" ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
